import { transition, trigger, style, animate } from '@angular/animations';

export const slideInFromBottomAnimation =
  trigger('slideInFromBottomAnimation', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateY(100%)' }),
      animate('0.2s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
    ]),
    transition(':leave', [
      style({ opacity: 1, transform: 'translateY(0)' }),
      animate('0.2s ease-out', style ({ opacity: 0, transform: 'translateY(100%)' }))
    ])
  ]);
